var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSquareLinearLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_5096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1891 0H57.773V5.41621H63.1891V0ZM5.41621 0.00085867H0V5.41707H5.41621V0.00085867ZM115.546 0H120.962V5.41621H115.546V0ZM34.3026 0H28.8865V5.41621H34.3026V0ZM86.6593 0H92.0755V5.41621H86.6593V0ZM149.848 0H144.433V5.41621H149.848V0ZM7.99065e-05 57.7727H5.41629V63.1889H7.99065e-05V57.7727ZM63.1891 57.7727H57.773V63.1889H63.1891V57.7727ZM115.546 57.7727H120.962V63.1889H115.546V57.7727ZM34.3026 57.7727H28.8865V63.1889H34.3026V57.7727ZM86.6593 57.7727H92.0755V63.1889H86.6593V57.7727ZM149.848 57.7727H144.433V63.1889H149.848V57.7727ZM7.99065e-05 115.545H5.41629V120.962H7.99065e-05V115.545ZM63.1891 115.545H57.773V120.962H63.1891V115.545ZM115.546 115.545H120.962V120.962H115.546V115.545ZM34.3026 115.545H28.8865V120.962H34.3026V115.545ZM86.6593 115.545H92.0755V120.962H86.6593V115.545ZM149.848 115.545H144.433V120.962H149.848V115.545ZM7.99065e-05 28.8867H5.41629V34.3029H7.99065e-05V28.8867ZM63.1891 28.8867H57.773V34.3029H63.1891V28.8867ZM115.546 28.8867H120.962V34.3029H115.546V28.8867ZM34.3026 28.8867H28.8865V34.3029H34.3026V28.8867ZM86.6593 28.8867H92.0755V34.3029H86.6593V28.8867ZM149.848 28.8867H144.433V34.3029H149.848V28.8867ZM7.99065e-05 86.6594H5.41629V92.0756H7.99065e-05V86.6594ZM63.1891 86.6594H57.773V92.0756H63.1891V86.6594ZM115.546 86.6594H120.962V92.0756H115.546V86.6594ZM34.3026 86.6594H28.8865V92.0756H34.3026V86.6594ZM86.6593 86.6594H92.0755V92.0756H86.6593V86.6594ZM149.848 86.6594H144.433V92.0756H149.848V86.6594ZM7.99065e-05 144.432H5.41629V149.849H7.99065e-05V144.432ZM63.1891 144.432H57.773V149.849H63.1891V144.432ZM115.546 144.432H120.962V149.849H115.546V144.432ZM34.3026 144.432H28.8865V149.849H34.3026V144.432ZM86.6593 144.432H92.0755V149.849H86.6593V144.432ZM149.848 144.432H144.433V149.849H149.848V144.432Z",
    fill: "url(#paint0_linear_119_5096)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_5096",
    x1: 153.655,
    y1: 10.0592,
    x2: -2.49156,
    y2: 23.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47CCDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_5096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSquareLinearLeft);
export default __webpack_public_path__ + "static/media/shape-square-linear--left.4097b3f7503b8f52c5757b6733dc5364.svg";
export { ForwardRef as ReactComponent };